import React from 'react';

export function Otsikko({ children, visible, setVisible }) {
  return (
    <button
      onClick={() => setVisible(!visible)}
      className={visible ? 'accordion-button' : 'accordion-button collapsed'}
    >
      <h1>{children}</h1>
    </button>
  );
}
